module.exports = "<div id=\"unauthorized\"><div class=\"card mx-auto\" style=\"width: 23rem;\"><div class=\"card-header text-white bg-danger\">Nincs jogosultsága az oldal megtekintéséhez!</div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/unauthorized/noaccess.component.pug
// module id = ./src/app/unauthorized/noaccess.component.pug
// module chunks = main